import * as React from 'react';
import Button from "@components/common/button/Button";
import ArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import ArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import AdjustDaysCalendar from './AdjustDaysCalendar';
import {adjustTemplate} from './CalendarCalc';
import TranslateNew from '@translate/TranslateNew';

import SwapIcon from "@components/svg/swapIcon";
import IconButton from "@components/common/iconButton/iconButton.component";
import {errorColor} from "../../../main.style";
import { IHoliday } from '@constants/holidays/holidayTypes';
import { withStyles, WithStyles } from '@material-ui/core';
import { GuideComponentStyles } from './guidecomponent.styles';

const tn: TranslateNew = TranslateNew.getInstance();


interface IAdjustDaysProps extends WithStyles<typeof GuideComponentStyles> {
    holidays: {[date: string]: IHoliday};
    schedule: boolean[];
    startDate: Date;
    endDate: Date;
    otherParent: string;
    myName: string;
    children: string[];
    setSchedule: (days: boolean[]) => void;
    extraWidth?:number;
    localization: 'en'|'se';
}

interface IState {
    highlight:boolean;
}


class AdjustDays extends React.Component<IAdjustDaysProps, IState> {

    constructor(props: any) {
        super(props);
        this.state = {
            highlight:false,
        }
        this.adjustOffset = this.adjustOffset.bind(this);
        this.invert = this.invert.bind(this);
    }

    public render() {

        return (
            <React.Fragment>
                <AdjustDaysCalendar
                    holidays={this.props.holidays}
                    schedule={this.props.schedule}
                    startDate={this.props.startDate}
                    endDate={this.props.endDate}
                    otherParent={this.props.otherParent}
                    myName={this.props.myName}
                    extraWidth={this.props.extraWidth}
                    localization={this.props.localization}
                />
                <div className={this.props.classes.row + " "+ this.props.classes.buttonsRow}>
                    <IconButton key="offsetBack" onClick={() => this.adjustOffset(false)} 
                        style={this.state.highlight?{backgroundColor:errorColor, transition:'all 0.2s'}:{transition:'all 0.2s'}}>
                        <ArrowLeftIcon/>
                    </IconButton>
                    <div style={{textAlign: 'center', textTransform: 'uppercase', fontWeight: 700}}
                        onClick={() =>{this.setState({highlight:true}); setTimeout(() => this.setState({highlight:false}), 200)}}>
                        {tn.lang.adjustDay}</div>
                    <IconButton key="offsetForward" onClick={() => this.adjustOffset(true)} 
                        style={this.state.highlight?{backgroundColor:errorColor, transition:'all 0.2s'}:{transition:'all 0.2s'}}>
                        <ArrowRightIcon/>
                    </IconButton>
                </div>
                <Button variant="contained" color="primary" size="medium" onClick={this.invert}
                    style={{alignSelf: 'center', background: 'linear-gradient(45deg, rgba(93,57,95,1) 0%, rgba(218,102,97,1) 100%)'}}>
                    <span style={{flex: 1, textAlign: 'left'}}>{tn.lang.invert}</span>
                    <SwapIcon fontSize="small" />
                </Button>
            </React.Fragment>
        );
    }

    private adjustOffset(add: boolean) {
        this.props.setSchedule(adjustTemplate(this.props.schedule, add ? 1 : -1, false));
        // this.setState({offset:(this.state.offset+(add?1:-1))});
    }

    private invert() {
        this.props.setSchedule(adjustTemplate(this.props.schedule, 0, true));
        // this.setState({invert:!this.state.invert});
    }
}

export default withStyles(GuideComponentStyles)(AdjustDays);


// WEBPACK FOOTER //
// ./src/components/guide/components/adjustDays.component.tsx